/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersPreferencesTechnicalSettingsOptions, GetUsersPreferencesTechnicalSettingsResponses } from '../types/GetUsersPreferencesTechnicalSettings'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/technical-settings/}
 */
export function getUsersPreferencesTechnicalSettings<ThrowOnError extends boolean = true>(options: Options<GetUsersPreferencesTechnicalSettingsOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetUsersPreferencesTechnicalSettingsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/users/preferences/technical-settings/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetUsersPreferencesTechnicalSettingsResponses, ThrowOnError>>)
}
